export default __webpack_public_path__ + "static/usman-12a06eb4e5d95af639bd110526950350.png";